import styled, { css } from 'styled-components';

import { mediaQuery } from '../../styles/mixin';

export const CardContainer = styled.div`
    width: 100%;
    max-width: 35rem;
    height: auto;
    background: white;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    border: ${({ theme }) => `1px solid ${theme.colors.lightShadow}`};
    border-radius: 0.5rem;
    ${mediaQuery(
        2,
        css`
            width: 35rem;
            padding: 2rem 5rem;
        `
    )}
`;
